import axios from "../../axios";
import {
  GET_TOKEN,
  ADD_JOURNEY,
  GET_CRIF_DATA,
  GET_CRIF_DB_DATA,
} from "../../constants";

// * API URLs (NEW)
import {
  GET_PROFILE_DETAILS,
  SEND_SMS_TO_CUSTOMER,
  RESEND_OTP_URL,
  GET_OFFER_SETTINGS,
  ContactID,
  TokenForCustomers,
} from "../../../constants/urls";

// * API to add journey data
const updateJourneyData = async (Payload) => {
  const res = await axios.post(ADD_JOURNEY);
  return res?.data;
};

// * API to to send the SMS to customer
const sendSMSToCustomer = async (Payload) => {
  const { phone, headers } = Payload;
  const res = await axios.post(SEND_SMS_TO_CUSTOMER, { phone }, { headers });
  return res?.data;
};

// * API to re-send OTP to customer
const resendOTP = async (Payload) => {
  const { payload, headers } = Payload;
  const res = await axios.post(process.env.REACT_APP_API_BASE_URL+RESEND_OTP_URL, payload, { headers });
  return res?.data;
};

// * API to get LSP/CI profile details (Disabled)
const getLenderProfileDetails = async (Payload) => {
  const headers = {
    apiKey: Payload.apiKey,
    apiSecret: Payload.apiSecret,
  };

  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}${GET_PROFILE_DETAILS}`,
    Payload,
    { headers }
  );
  return res?.data;
};

const getCRIFData = async (Payload) => {
  // * Get Auth token before executing API
  let authToken = null;
  authToken = localStorage.getItem("authToken");

  if (!authToken) {
    // * Auth token not availabe in local storage then fetch it.
    authToken = await getToken();
  }

  const headers = {
    ...Payload.headers,
    Authorization: `Bearer ${authToken}`,
  };
  delete Payload.headers;

  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}${GET_CRIF_DATA}`,
    Payload,
    { headers }
  );
  return res?.data;
};

const getCRIFData_DB = async (Payload) => {
  // * Get Auth token before executing API
  let authToken = null;
  authToken = localStorage.getItem("authToken");

  if (!authToken) {
    // * Auth token not availabe in local storage then fetch it.
    authToken = await getToken();
  }
  const headers = {
    ...Payload.headers,
    Authorization: `Bearer ${authToken}`,
  };
  delete Payload.headers;

  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}${GET_CRIF_DB_DATA}`,
    Payload,
    {
      headers,
    }
  );
  return res?.data;
};

const getToken = async () => {
  const res = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}${GET_TOKEN}`
  );
  let authToken = res?.data.data.token;
  localStorage.setItem("authToken", authToken);

  return authToken;
};

const getOfferSettings = async (Payload) => {
  // * Get Auth token before executing API
  let authToken = null;
  authToken = localStorage.getItem("authToken");

  if (!authToken) {
    // * Auth token not availabe in local storage then fetch it.
    authToken = await getToken();
  }

  const headers = {
    ...Payload.headers,
    Authorization: `Bearer ${authToken}`,
  };

  delete Payload.headers;
  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}${GET_OFFER_SETTINGS}`,
    Payload,
    { headers }
  );
  return res?.data;
};

export {
  getLenderProfileDetails,
  updateJourneyData,
  getCRIFData,
  getCRIFData_DB,
  getToken,
  sendSMSToCustomer,
  resendOTP,
  getOfferSettings,
};
